import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { RootState } from "@/redux/reducers";
import { PharmaAddressDetails } from "@/redux/slice/location/interfaces/PharmaAddressDetails";

const selectLocation = (state: RootState) => state?.location;

export default createDraftSafeSelector(selectLocation, (location) => {
  const pharmaAddressDetails: PharmaAddressDetails = {
    state: location?.state,
    city: location?.city,
    country: location?.country,
    pincode: location?.pincode,
    lat: location?.latitude?.toString(),
    lng: location?.longitude?.toString(),
    tatInput: location?.tatInput,
  };

  return pharmaAddressDetails;
});
